/*
  Trang "Track your order" — xem sections/order-tracking.liquid cho bối cảnh.

  BA ĐIỀU PHẢI GIỮ, ĐỪNG "DỌN GỌN" MẤT

  1. SCRIPT 17TRACK NẠP MUỘN VÀ CHỈ MỘT LẦN. Nạp lúc mở trang là thêm một script
     bên thứ ba chặn render, đúng thứ đã làm trang sản phẩm chậm. `loadWidget()`
     giữ lại chính Promise của lần nạp đầu, nên bấm Track mười lần vẫn chỉ một
     thẻ <script>.

  2. LUÔN CÓ ĐƯỜNG LUI. `externalcall.js` là mã của bên thứ ba, họ đổi hay bỏ
     lúc nào mình không biết. Hết SCRIPT_TIMEOUT_MS mà chưa có `YQV5` thì đổi
     khối kết quả thành link sang t.17track.net. Trang vẫn dùng được trong ngày
     17track đổi API — đừng bỏ nhánh này vì "chạy tốt mà".

  3. FORM VẪN SUBMIT ĐƯỢC KHI KHÔNG CÓ JS. Form là GET về chính trang này với
     `name="nums"`, nên mất JS thì nạp lại trang kèm ?nums=... và lần sau JS tự
     tra. `event.preventDefault()` chỉ gọi khi mình chắc chắn xử lý được.

  ĐỊNH DẠNG MÃ VẬN ĐƠN: chỉ chuẩn hoá nhẹ (bỏ khoảng trắng, viết hoa) rồi kiểm
  độ dài. KHÔNG regex theo hãng vận chuyển — store dùng nhiều nhà cung cấp POD,
  mỗi bên một kiểu mã, chặn nhầm thì khách không tra được mà cũng không hiểu vì sao.
*/

/*
  TÊN PHƯƠNG THỨC — ĐÃ GỌI SAI MỘT LẦN, ĐỪNG LẶP LẠI

  `externalcall.js` (đọc bản thật 28/08/2026) chỉ có 4 phương thức trên
  `window.YQV5`: `trackSingle`, `trackMulti`, `trackSingleF1`, `trackSingleF2`.
  **KHÔNG có `trackSingleF`** — tên đó lấy từ tài liệu cũ trôi nổi, gọi vào là
  TypeError, rơi thẳng vào nhánh dự phòng mà nhìn cứ tưởng 17track chết.

  Chọn `trackSingle`: nó gọi `doTrackAppend`, nhận sẵn số và chèn iframe kết quả
  vào khối. `trackMulti` chỉ nhúng form nhập nhiều mã, không nhận số. F1 gắn
  handler click chứ không vẽ gì.

  THAM SỐ LÀ `YQ_ContainerId`, KHÔNG PHẢI `YQ_ElementId`. `doTrackAppend` đọc
  đúng khoá đó; F1/F2 mới dùng `YQ_ElementId`. Đưa nhầm khoá thì nó không tìm
  thấy khối, không vẽ, và cũng không báo lỗi.
*/
const SCRIPT_SRC = 'https://www.17track.net/externalcall.js';
const SCRIPT_TIMEOUT_MS = 6000;
const IFRAME_TIMEOUT_MS = 8000;
const MIN_LENGTH = 6;
const MAX_LENGTH = 40;

/** Promise của lần nạp script đầu tiên; null khi chưa ai bấm Track. */
let widgetLoader = null;

function loadWidget() {
  if (widgetLoader) return widgetLoader;

  widgetLoader = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.async = true;

    /* `onload` bắn khi tệp về, nhưng `YQV5` là biến toàn cục do tệp đó tạo —
       có trường hợp tệp về mà biến chưa có (họ đổi tên, hoặc bị chặn giữa
       chừng). Nên kiểm chính biến chứ không tin onload. */
    const timer = setTimeout(() => {
      reject(new Error('17track script timed out'));
    }, SCRIPT_TIMEOUT_MS);

    script.addEventListener('load', () => {
      clearTimeout(timer);
      if (typeof window.YQV5 === 'undefined') {
        reject(new Error('17track loaded but YQV5 is missing'));
        return;
      }
      resolve(window.YQV5);
    });

    script.addEventListener('error', () => {
      clearTimeout(timer);
      reject(new Error('17track script failed to load'));
    });

    document.head.appendChild(script);
  }).catch((err) => {
    /* Cho phép thử lại ở lần bấm sau — mạng khách có thể vừa chập một nhịp. */
    widgetLoader = null;
    throw err;
  });

  return widgetLoader;
}

function normalize(raw) {
  return String(raw || '')
    .replace(/\s+/g, '')
    .toUpperCase();
}

class OrderTracking extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('[ref="form"]');
    this.input = this.querySelector('[ref="input"]');
    this.submit = this.querySelector('[ref="submit"]');
    this.result = this.querySelector('[ref="result"]');
    this.error = this.querySelector('[ref="error"]');

    if (!this.form || !this.input || !this.result) return;

    this.lang = this.dataset.widgetLang || 'en';
    this.height = parseInt(this.dataset.widgetHeight, 10) || 560;

    this.onSubmit = this.onSubmit.bind(this);
    this.form.addEventListener('submit', this.onSubmit);

    /* Mở trang kèm ?nums= thì điền sẵn và tra luôn, khỏi bắt khách bấm thêm một
       lần. Phải đọc ở đây chứ không đổ từ Liquid: object `request` của Shopify
       không phơi query string ra. */
    const preset = normalize(this.readPreset());
    if (preset.length >= MIN_LENGTH && preset.length <= MAX_LENGTH) {
      this.input.value = preset;
      this.track(preset);
    }
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.onSubmit);
  }

  /** Mã trên URL, rỗng nếu không có hoặc URL không dựng được. */
  readPreset() {
    try {
      return new URLSearchParams(window.location.search).get('nums') || '';
    } catch (_) {
      return '';
    }
  }

  onSubmit(event) {
    const value = normalize(this.input.value);

    if (value.length < MIN_LENGTH || value.length > MAX_LENGTH) {
      /* Để form tự nạp lại trang thì cũng không giúp được gì — chặn tại chỗ và
         nói rõ vấn đề. */
      event.preventDefault();
      this.showError(
        `That does not look like a tracking number. It should be between ${MIN_LENGTH} and ${MAX_LENGTH} characters.`
      );
      this.input.focus();
      return;
    }

    event.preventDefault();
    this.input.value = value;
    this.track(value);

    /* Cập nhật URL để khách bookmark hoặc bấm F5 vẫn ra đúng mã. `replaceState`
       chứ không `pushState` — tra 5 mã liên tiếp rồi bấm Back mà phải bấm 5 lần
       mới thoát được trang thì rất khó chịu. */
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('nums', value);
      window.history.replaceState({}, '', url);
    } catch (_) {
      /* URL không dựng được thì thôi, không ảnh hưởng việc tra. */
    }
  }

  showError(message) {
    if (!this.error) return;
    this.error.textContent = message;
    this.error.hidden = false;
  }

  clearError() {
    if (!this.error) return;
    this.error.textContent = '';
    this.error.hidden = true;
  }

  setBusy(busy) {
    if (this.submit) this.submit.disabled = busy;
    this.result.innerHTML = busy ? '<span class="order-tracking__spinner" role="status" aria-label="Loading"></span>' : '';
  }

  track(number) {
    this.clearError();
    this.setBusy(true);

    loadWidget()
      .then((YQV5) => {
        /* `doTrackAppend` tìm khối bằng document.getElementById, nên bắt buộc
           phải có id. Nó tự xoá sạch con cũ trước khi chèn iframe. */
        if (!this.result.id) {
          this.result.id = `order-tracking-result-${Math.random().toString(36).slice(2, 8)}`;
        }

        YQV5.trackSingle({
          YQ_ContainerId: this.result.id,
          YQ_Height: this.height,
          YQ_Fc: '0',
          YQ_Lang: this.lang,
          YQ_Num: number,

          /*
            TẮT QUẢNG CÁO VÀ BANNER CỦA 17TRACK.

            Mặc định widget chèn quảng cáo bên thứ ba vào giữa khung kết quả —
            đo trên live 28/08/2026 là một banner "SHINSEGAE DUTY FREE" kèm nút
            Open, ngay trên trang bán hàng của mình. `YQ_RmAD` bỏ nó, `YQ_RmHeader`
            bỏ dải "Free to Download the 17TRACK Apps".

            Hai khoá này đọc từ chính `doTrackAppend` trong externalcall.js
            (`rmad`, `rmh` trong query của iframe). KHÔNG bật `YQ_RmLink` — nó gỡ
            luôn link tên hãng vận chuyển, thứ khách cần để sang trang hãng.
          */
          YQ_RmAD: true,
          YQ_RmHeader: true,
        });

        /* trackSingle KHÔNG trả về gì và nuốt lỗi: `doTrackAppend` có nhánh
           `return !1` mà không báo ra ngoài. Nên đừng tin là gọi xong là xong —
           chờ xem iframe có thật sự xuất hiện không, không thì bật đường lui. */
        return this.waitForIframe();
      })
      .catch(() => {
        this.renderFallback(number);
      })
      .finally(() => {
        if (this.submit) this.submit.disabled = false;
      });
  }

  /**
   * Đợi 17track chèn iframe vào khối kết quả. Reject nếu quá IFRAME_TIMEOUT_MS —
   * đó là tín hiệu duy nhất mình có để biết nó thất bại, vì trackSingle im lặng.
   */
  waitForIframe() {
    return new Promise((resolve, reject) => {
      const deadline = Date.now() + IFRAME_TIMEOUT_MS;

      const check = () => {
        if (this.result.querySelector('iframe')) {
          resolve();
          return;
        }
        if (Date.now() > deadline) {
          reject(new Error('17track rendered no iframe'));
          return;
        }
        setTimeout(check, 120);
      };

      check();
    });
  }

  renderFallback(number) {
    const url = `https://t.17track.net/en#nums=${encodeURIComponent(number)}`;
    this.result.innerHTML = `
      <div class="order-tracking__result-fallback">
        <p>We could not load the tracking view here.</p>
        <p><a href="${url}" target="_blank" rel="noopener">Track ${number} on 17TRACK</a></p>
      </div>
    `;
  }
}

if (!customElements.get('order-tracking')) {
  customElements.define('order-tracking', OrderTracking);
}
